export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos',
      services: 'Services',
      portfolio: 'Portfolio',
      blog: 'Blog',
      testimonials: 'Témoignages',
      contact: 'Contact'
    },
    hero: {
      title: 'Nous faisons de votre rêve une réalité',
      subtitle: 'Architecture et Décoration d\'Intérieur de Luxe',
      description: 'Transformez vos espaces avec RADIA SARL - Votre partenaire pour des designs contemporains et élégants au Cameroun',
      cta: 'Découvrir nos réalisations'
    },
    about: {
      title: 'À Propos de RADIA SARL',
      subtitle: 'Excellence et Innovation depuis 2022',
      mission: 'Notre Mission',
      missionText: 'Contribuer à améliorer le design d\'intérieur au Cameroun à travers des services complets : conception 3D, architecture d\'intérieur, décoration, rénovation, construction, aménagement de jardins et piscines, fabrication de meubles sur mesure, et suivi de chantier.',
      location: 'Nos Bureaux',
      locationText: 'Basés à Douala et Yaoundé, nous servons une clientèle haut de gamme composée de particuliers et d\'entreprises à travers le Cameroun.',
      expertise: 'Notre Expertise',
      expertiseText: 'Fondée en 2022, RADIA SARL s\'est rapidement imposée comme un acteur majeur du design d\'intérieur contemporain au Cameroun, alliant savoir-faire local et standards internationaux.'
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Des solutions complètes pour tous vos projets',
      items: [
        {
          title: 'Architecture d\'Intérieur',
          description: 'Conception et planification d\'espaces fonctionnels et esthétiques adaptés à vos besoins'
        },
        {
          title: 'Décoration 3D',
          description: 'Visualisation réaliste de vos projets grâce à la modélisation 3D de pointe'
        },
        {
          title: 'Rénovation Complète',
          description: 'Transformation totale de vos espaces existants avec une attention aux détails'
        },
        {
          title: 'Aménagement sur Mesure',
          description: 'Solutions personnalisées adaptées à votre style de vie et votre budget'
        },
        {
          title: 'Construction',
          description: 'Gestion complète de projets de construction résidentielle et commerciale'
        },
        {
          title: 'Jardins & Piscines',
          description: 'Création d\'espaces extérieurs luxueux et relaxants'
        },
        {
          title: 'Meubles sur Mesure',
          description: 'Fabrication de mobilier unique adapté à vos espaces'
        },
        {
          title: 'Suivi de Chantier',
          description: 'Accompagnement professionnel tout au long de votre projet'
        }
      ]
    },
    portfolio: {
      title: 'Notre Portfolio',
      subtitle: 'Découvrez nos réalisations exceptionnelles',
      projects: [
        {
          title: 'Villa Moderne Douala',
          category: 'Résidentiel',
          description: 'Rénovation complète d\'une villa avec piscine et jardin paysager'
        },
        {
          title: 'Appartement Luxe Yaoundé',
          category: 'Résidentiel',
          description: 'Décoration contemporaine d\'un appartement haut de gamme'
        },
        {
          title: 'Bureau Executive',
          category: 'Commercial',
          description: 'Aménagement d\'espaces de bureau modernes et fonctionnels'
        },
        {
          title: 'Cuisine Contemporaine',
          category: 'Résidentiel',
          description: 'Cuisine sur mesure avec finitions luxueuses'
        },
        {
          title: 'Salle de Bain Spa',
          category: 'Résidentiel',
          description: 'Transformation en espace de détente luxueux'
        },
        {
          title: 'Résidence Akwa',
          category: 'Résidentiel',
          description: 'Architecture et décoration d\'une résidence familiale'
        },
        {
          title: 'Showroom Design',
          category: 'Commercial',
          description: 'Espace commercial élégant et attractif'
        },
        {
          title: 'Jardin Tropical',
          category: 'Extérieur',
          description: 'Aménagement paysager avec piscine à débordement'
        }
      ]
    },
    blog: {
      title: 'Blog & Conseils',
      subtitle: 'Actualités et tendances en décoration',
      readMore: 'Lire plus',
      articles: [
        {
          title: '10 Tendances Déco 2024 au Cameroun',
          excerpt: 'Découvrez les tendances qui transforment les intérieurs camerounais : matériaux naturels, couleurs terreuses, et mobilier artisanal local.',
          date: '15 Mars 2024',
          category: 'Tendances'
        },
        {
          title: 'Comment Optimiser un Petit Espace',
          excerpt: 'Nos astuces d\'architecte pour maximiser chaque mètre carré : rangements intelligents, miroirs stratégiques, et choix de couleurs.',
          date: '8 Mars 2024',
          category: 'Conseils'
        },
        {
          title: 'L\'Art de Mélanger Moderne et Traditionnel',
          excerpt: 'Intégrez harmonieusement les éléments culturels camerounais dans un design contemporain pour un intérieur unique et authentique.',
          date: '1 Mars 2024',
          category: 'Design'
        },
        {
          title: 'Guide: Choisir ses Matériaux de Luxe',
          excerpt: 'Marbre, bois précieux, tissus nobles : notre guide complet pour sélectionner les meilleurs matériaux pour votre projet haut de gamme.',
          date: '22 Février 2024',
          category: 'Guides'
        }
      ]
    },
    testimonials: {
      title: 'Témoignages Clients',
      subtitle: 'Ce que nos clients disent de nous',
      items: [
        {
          name: 'Marie-Claude Ngo',
          role: 'Propriétaire, Douala',
          text: 'RADIA SARL a transformé notre maison en un véritable bijou architectural. Leur attention aux détails et leur professionnalisme sont exceptionnels.'
        },
        {
          name: 'Jean-Paul Kamdem',
          role: 'Directeur Général, Yaoundé',
          text: 'L\'aménagement de nos bureaux a dépassé toutes nos attentes. L\'équipe de RADIA comprend vraiment les besoins des entreprises modernes.'
        },
        {
          name: 'Sophie Mballa',
          role: 'Architecte, Douala',
          text: 'Collaborer avec RADIA fut un plaisir. Leur expertise en design 3D nous a permis de visualiser parfaitement le projet avant réalisation.'
        },
        {
          name: 'Daniel Fotso',
          role: 'Entrepreneur, Yaoundé',
          text: 'De la conception à la livraison, tout a été impeccable. RADIA SARL est définitivement le partenaire idéal pour des projets haut de gamme.'
        },
        {
          name: 'Élisabeth Tchoupe',
          role: 'Propriétaire, Douala',
          text: 'Notre cuisine et salle de bain ont été entièrement refaites. Le résultat est magnifique et la qualité des finitions irréprochable.'
        }
      ]
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Démarrons votre projet ensemble',
      form: {
        name: 'Nom complet',
        email: 'Email',
        phone: 'Téléphone',
        city: 'Ville',
        cityPlaceholder: 'Sélectionnez votre ville',
        cities: ['Douala', 'Yaoundé', 'Autre'],
        service: 'Service souhaité',
        servicePlaceholder: 'Sélectionnez un service',
        services: [
          'Architecture d\'intérieur',
          'Décoration 3D',
          'Rénovation',
          'Aménagement sur mesure',
          'Construction',
          'Piscine et jardin',
          'Meubles sur mesure',
          'Suivi de chantier'
        ],
        budget: 'Budget estimé (XAF)',
        budgetPlaceholder: 'Sélectionnez une fourchette',
        budgets: ['< 1M XAF', '1M - 5M XAF', '5M - 10M XAF', '> 10M XAF'],
        message: 'Votre message',
        messagePlaceholder: 'Décrivez votre projet...',
        submit: 'Envoyer',
        sending: 'Envoi en cours...'
      },
      info: {
        title: 'Informations',
        address: 'Douala & Yaoundé, Cameroun',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        hours: 'Lun - Ven: 8h - 18h'
      },
      success: 'Message envoyé avec succès! Nous vous contacterons bientôt.',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.'
    },
    footer: {
      tagline: 'Excellence en Architecture et Décoration',
      about: 'À propos',
      aboutText: 'RADIA SARL, fondée en 2022, est votre partenaire de confiance pour tous vos projets d\'architecture et de décoration d\'intérieur au Cameroun.',
      quickLinks: 'Liens Rapides',
      followUs: 'Suivez-nous',
      rights: 'Tous droits réservés.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      portfolio: 'Portfolio',
      blog: 'Blog',
      testimonials: 'Testimonials',
      contact: 'Contact'
    },
    hero: {
      title: 'We Make Your Dream a Reality',
      subtitle: 'Luxury Architecture and Interior Design',
      description: 'Transform your spaces with RADIA SARL - Your partner for contemporary and elegant designs in Cameroon',
      cta: 'Discover our work'
    },
    about: {
      title: 'About RADIA SARL',
      subtitle: 'Excellence and Innovation since 2022',
      mission: 'Our Mission',
      missionText: 'To contribute to improving interior design in Cameroon through comprehensive services: 3D design, interior architecture, decoration, renovation, construction, garden and pool landscaping, custom furniture manufacturing, and site supervision.',
      location: 'Our Offices',
      locationText: 'Based in Douala and Yaoundé, we serve high-end clientele of individuals and businesses throughout Cameroon.',
      expertise: 'Our Expertise',
      expertiseText: 'Founded in 2022, RADIA SARL has quickly established itself as a major player in contemporary interior design in Cameroon, combining local expertise with international standards.'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Complete solutions for all your projects',
      items: [
        {
          title: 'Interior Architecture',
          description: 'Design and planning of functional and aesthetic spaces tailored to your needs'
        },
        {
          title: '3D Decoration',
          description: 'Realistic visualization of your projects through cutting-edge 3D modeling'
        },
        {
          title: 'Complete Renovation',
          description: 'Total transformation of your existing spaces with attention to detail'
        },
        {
          title: 'Custom Design',
          description: 'Personalized solutions adapted to your lifestyle and budget'
        },
        {
          title: 'Construction',
          description: 'Complete management of residential and commercial construction projects'
        },
        {
          title: 'Gardens & Pools',
          description: 'Creation of luxurious and relaxing outdoor spaces'
        },
        {
          title: 'Custom Furniture',
          description: 'Manufacturing of unique furniture adapted to your spaces'
        },
        {
          title: 'Site Supervision',
          description: 'Professional support throughout your project'
        }
      ]
    },
    portfolio: {
      title: 'Our Portfolio',
      subtitle: 'Discover our exceptional achievements',
      projects: [
        {
          title: 'Modern Villa Douala',
          category: 'Residential',
          description: 'Complete renovation of a villa with pool and landscaped garden'
        },
        {
          title: 'Luxury Apartment Yaoundé',
          category: 'Residential',
          description: 'Contemporary decoration of a high-end apartment'
        },
        {
          title: 'Executive Office',
          category: 'Commercial',
          description: 'Modern and functional office space design'
        },
        {
          title: 'Contemporary Kitchen',
          category: 'Residential',
          description: 'Custom kitchen with luxurious finishes'
        },
        {
          title: 'Spa Bathroom',
          category: 'Residential',
          description: 'Transformation into a luxurious relaxation space'
        },
        {
          title: 'Akwa Residence',
          category: 'Residential',
          description: 'Architecture and decoration of a family residence'
        },
        {
          title: 'Design Showroom',
          category: 'Commercial',
          description: 'Elegant and attractive commercial space'
        },
        {
          title: 'Tropical Garden',
          category: 'Exterior',
          description: 'Landscape design with infinity pool'
        }
      ]
    },
    blog: {
      title: 'Blog & Tips',
      subtitle: 'News and trends in decoration',
      readMore: 'Read more',
      articles: [
        {
          title: '10 Deco Trends 2024 in Cameroon',
          excerpt: 'Discover the trends transforming Cameroonian interiors: natural materials, earthy colors, and local artisan furniture.',
          date: 'March 15, 2024',
          category: 'Trends'
        },
        {
          title: 'How to Optimize a Small Space',
          excerpt: 'Our architect tips to maximize every square meter: smart storage, strategic mirrors, and color choices.',
          date: 'March 8, 2024',
          category: 'Tips'
        },
        {
          title: 'The Art of Mixing Modern and Traditional',
          excerpt: 'Harmoniously integrate Cameroonian cultural elements into contemporary design for a unique and authentic interior.',
          date: 'March 1, 2024',
          category: 'Design'
        },
        {
          title: 'Guide: Choosing Luxury Materials',
          excerpt: 'Marble, precious wood, noble fabrics: our complete guide to selecting the best materials for your high-end project.',
          date: 'February 22, 2024',
          category: 'Guides'
        }
      ]
    },
    testimonials: {
      title: 'Client Testimonials',
      subtitle: 'What our clients say about us',
      items: [
        {
          name: 'Marie-Claude Ngo',
          role: 'Homeowner, Douala',
          text: 'RADIA SARL transformed our house into a true architectural gem. Their attention to detail and professionalism are exceptional.'
        },
        {
          name: 'Jean-Paul Kamdem',
          role: 'CEO, Yaoundé',
          text: 'The design of our offices exceeded all our expectations. RADIA team truly understands the needs of modern businesses.'
        },
        {
          name: 'Sophie Mballa',
          role: 'Architect, Douala',
          text: 'Collaborating with RADIA was a pleasure. Their expertise in 3D design allowed us to visualize the project perfectly before execution.'
        },
        {
          name: 'Daniel Fotso',
          role: 'Entrepreneur, Yaoundé',
          text: 'From design to delivery, everything was impeccable. RADIA SARL is definitely the ideal partner for high-end projects.'
        },
        {
          name: 'Élisabeth Tchoupe',
          role: 'Homeowner, Douala',
          text: 'Our kitchen and bathroom were completely redone. The result is beautiful and the quality of finishes impeccable.'
        }
      ]
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Let\'s start your project together',
      form: {
        name: 'Full name',
        email: 'Email',
        phone: 'Phone',
        city: 'City',
        cityPlaceholder: 'Select your city',
        cities: ['Douala', 'Yaoundé', 'Other'],
        service: 'Desired service',
        servicePlaceholder: 'Select a service',
        services: [
          'Interior architecture',
          '3D decoration',
          'Renovation',
          'Custom design',
          'Construction',
          'Pool and garden',
          'Custom furniture',
          'Site supervision'
        ],
        budget: 'Estimated budget (XAF)',
        budgetPlaceholder: 'Select a range',
        budgets: ['< 1M XAF', '1M - 5M XAF', '5M - 10M XAF', '> 10M XAF'],
        message: 'Your message',
        messagePlaceholder: 'Describe your project...',
        submit: 'Send',
        sending: 'Sending...'
      },
      info: {
        title: 'Information',
        address: 'Douala & Yaoundé, Cameroon',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        hours: 'Mon - Fri: 8am - 6pm'
      },
      success: 'Message sent successfully! We will contact you soon.',
      error: 'Error sending. Please try again.'
    },
    footer: {
      tagline: 'Excellence in Architecture and Decoration',
      about: 'About',
      aboutText: 'RADIA SARL, founded in 2022, is your trusted partner for all your architecture and interior design projects in Cameroon.',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      rights: 'All rights reserved.'
    }
  }
};
